import { useTranslation } from "react-i18next";
import { SliderPageWrapper } from "../../../layout/sliderPageWrapper/SliderPageWrapper";
import { AddPaymentMethods, PaymentActionType } from "./AddPaymentMethods";

export interface AddPaymentMethodsProps {
  editMode?: boolean;
}

export const AddPaymentMethodsPage: React.FC<AddPaymentMethodsProps> = () => {
  const { t } = useTranslation(["common"]);
  return (
    <SliderPageWrapper headerTitle={t("add_payment_method", {
      value: ""
    })}>
      <AddPaymentMethods paymentActionType={PaymentActionType.SAVE} />
    </SliderPageWrapper>
  );
};
